import { IntelligentPhotoCaptureShutterSoundFilterType } from '../enums';
export const IntelligentPhotoCaptureShutterMinGain = 0.001;
export const IntelligentPhotoCaptureShutterBurstSequence = [
    {
        timeOffset: 0,
        duration: 0.15,
        filterType: IntelligentPhotoCaptureShutterSoundFilterType.HIGHPASS,
        filterFreq: 4000,
        peakGain: 0.9,
        attack: 0.0005
    },
    {
        timeOffset: 0.002,
        duration: 0.04,
        filterType: IntelligentPhotoCaptureShutterSoundFilterType.BANDPASS,
        filterFreq: 350,
        filterQ: 0.8,
        peakGain: 0.5,
        attack: 0.001
    },
    {
        timeOffset: 0.06,
        duration: 0.12,
        filterType: IntelligentPhotoCaptureShutterSoundFilterType.HIGHPASS,
        filterFreq: 3500,
        peakGain: 0.7,
        attack: 0.0005
    },
    {
        timeOffset: 0.065,
        duration: 0.25,
        filterType: IntelligentPhotoCaptureShutterSoundFilterType.BANDPASS,
        filterFreq: 300,
        filterQ: 0.7,
        peakGain: 0.3,
        attack: 0.001
    }
];
//# sourceMappingURL=IntelligentPhotoCaptureShutterSoundConstants.js.map